<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';
import { useUserLanguage } from 'dashboard/composables/useUserLanguage';
import { activityMessageText } from 'dashboard/helper/activityMessageText';

const { content, createdAt, contentAttributes } = useMessageContext();
const { userLanguage } = useUserLanguage();
const { t, te } = useI18n();

// NOTICE: KAPTION-INTEGRATION — the text lives in a helper, shared with note-cards.GROUP.
const renderedContent = computed(() =>
  activityMessageText(
    { content: content.value, contentAttributes: contentAttributes?.value },
    { t, te }
  )
);

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a', userLanguage?.value)
);
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="renderedContent" :title="renderedContent" />
  </BaseBubble>
</template>
